import React from 'react';
import config from '../config'
import './ShareJoinlinkDropdownButton.css';
import { translationsHelper } from '../helpers/TranslationsHelper';
import { TranslationKeys } from '../configuration/IConfiguration';
import { ApplicationContext, ApplicationActionType } from '../context/ApplicationContext';
import { Flex, Popup, Button,Image, Box } from '@stardust-ui/react'
import { clipboardHelper } from '../helpers/ClipboardHelper';
import { logger } from '../helpers/LoggerHelper';
import { deviceType, os, DeviceTypes, OperatingSystems } from '../helpers/EnvironmentHelper';

const ShareJoinlinkDropdownButton: React.FC = () => {

    const { state, dispatch } = React.useContext(ApplicationContext);
    const [popupOpened, setPopupOpened] = React.useState(false);

    const shareViaOutlook = () => {
        setPopupOpened(false);
        logger.ClickedOnPopupItemShareViaOutlook();        
        if (state.LatestJoinLink) {
            const mailsubject = encodeURIComponent(translationsHelper.GetTranslation(TranslationKeys.share_joinlink_email_body_title));
            const mailBody = translationsHelper.GetTranslation(TranslationKeys.share_joinlink_email_body_text);
            const fullMailBody = mailBody + " " + state.LatestJoinLink;
            const fullUrl = `https://outlook.office.com/mail/deeplink/compose?subject=${mailsubject}&body=${fullMailBody}`;
            window.open(fullUrl, "_blank");
          }
    };

    const shareViaGmail = () => {
        setPopupOpened(false);
        logger.ClickedOnPopupItemShareViaGmail();        
        if (state.LatestJoinLink) {
            const mailsubject = encodeURIComponent(translationsHelper.GetTranslation(TranslationKeys.share_joinlink_email_body_title));
            const mailBody = translationsHelper.GetTranslation(TranslationKeys.share_joinlink_email_body_text);
            const fullMailBody = mailBody + " " + state.LatestJoinLink;

            let fullUrl = "";
            if (deviceType === DeviceTypes.Mobile)
            {
              if (os === OperatingSystems.iOS )
              {
                fullUrl = `mailto:?subject=${mailsubject}&body=${fullMailBody}`;
                window.top.location.href = fullUrl;
              }
              else
              {
                fullUrl = `mailto:?subject=${mailsubject}&body=${fullMailBody}`;
                window.open(fullUrl, "_blank");
              }
            }
            else 
            {
                fullUrl = `https://mail.google.com/mail/?view=cm&fs=1&tf=1&su=${mailsubject}&body=${fullMailBody}`;
                window.open(fullUrl, "_blank");
            }
          }
    };

    const copyJoinLinkToClipboard = () => {
        setPopupOpened(false);
        logger.ClickedOnPopupItemCopyToClipboard();        
        dispatch({
          Action: ApplicationActionType.LinkWasCopiedToClipboard,
          Payload: true
        });

        if (state.LatestJoinLink) {
          clipboardHelper.copyToClipboard(state.LatestJoinLink);
        }
      };

      const text = (
        <Button size="largest"
            variables={{
                backgroundColorHover: '#004e8c',
                borderRadius: '100px',
                color: 'white',
                height: '60px',
                backgroundColorActive: '#2b2c33',
                colorActive: 'white',
                maxWidth: '100%',
                minWidth: '100%',
                backgroundColor: '#0078ca',
                colorHover: 'white'
            }}
            styles={{
                "@media only screen and (max-width: 400px)": {
                  height: '50px',
                  }
          }} icon="chevron-down" content={() => <Box content={translationsHelper.GetTranslation(TranslationKeys.share_title)} styles={{
            fontSize: "20px",
            fontWeight: "bold",
            "@media only screen and (max-width: 400px)": {
              fontSize: "18px"
          }}} />} iconPosition="after" />
      );

    const iconCopy = `${config.ecs.cdnHost}/assets/v2/CopyLink@1x.png`
    const iconGmail = `${config.ecs.cdnHost}/assets/v2/Gmail@1x.png`
    const iconOutlook = `${config.ecs.cdnHost}/assets/v2/Outlook@1x.png`

      const contentCopyLink = (
        <div className="popupItem">
        <div className="popupItemImg">
        <Image styles={{
            width: '20px',
            height: '20px',
          }} src={iconCopy} />
        </div>
          <span className="popupItemText">
          {translationsHelper.GetTranslation(TranslationKeys.copy_link_title)}
          </span>
          </div>
    );

    const contentShareOnOutlook = (
      <div className="popupItem">
        <div className="popupItemImg">
          <Image styles={{
              width: '20px',
              height: '20px',
            }} src={iconOutlook} /> 
        </div>
        <span className="popupItemText">{translationsHelper.GetTranslation(TranslationKeys.outlook_share_button_text)}</span>
        </div>
  );    

  const contentShareOnGmail = (
    <div className="popupItem">
        <div className="popupItemImg">
        <Image styles={{
            marginTop: '3px',
            width: '20px',
            height: '20px',
          }} src={iconGmail} />
      </div>
      <span className="popupItemText">
      {translationsHelper.GetTranslation(TranslationKeys.gmail_share_button_text)}
      </span>
      </div>
);     

      const contentWithButtons = (
        <Flex  gap="gap.smaller" column >
            <Button styles={{ justifyContent: 'left' }} content={contentCopyLink} text onClick={copyJoinLinkToClipboard} />
            <Button styles={{ justifyContent: 'left' }} content={contentShareOnOutlook} text onClick={shareViaOutlook} />
            <Button styles={{ justifyContent: 'left' }} content={contentShareOnGmail} text onClick={shareViaGmail} />
        </Flex>
      )      

    return (
        <div className="dropdownmenu">
            <Popup position="below" align="center" open={popupOpened}
            onOpenChange={(e: any, props: any) => {
              if (props) {
                if (props.open) {
                  setPopupOpened(true);
                  return;
                }
              }
              setPopupOpened(false)
            }}
            trigger={text}
            content={{
              styles: { borderRadius: '10px'},
              content: contentWithButtons,
              animation: "fadeEnterFast",
            }}
            trapFocus
            on="click"
          />
        </div>
    );
}

export default ShareJoinlinkDropdownButton;
